/**
 * Health Check: Envia pongs periódicos para o C# monitorar status do frontend
 * 
 * Conforme padrão oficial em COMMUNICATION_STANDARD.md, o frontend deve enviar
 * health:pong a cada 15 segundos para que o C# saiba que está ativo.
 */

import { corelCommunication } from './communication';

const HEALTH_CHECK_INTERVAL = 15000; // 15 segundos para manter margem folgada sob o threshold de 40s do backend

function emitHealthPong(): void {
  const apiOnline = (window as any).__API_ONLINE ?? true;
  const token = (window as any)?.sessionToken;
  const hasValidToken = typeof token === 'string' && token.length === 64 && /^[a-fA-F0-9]+$/.test(token);

  // Se não houver token válido, apenas logar em nível debug e pular este tick
  if (!hasValidToken) {
    if ((window as any)?.__DEBUG_LOGS__ !== false) {
      console.debug('⏳ [HEALTH] WAITING_TOKEN', { timestamp: Date.now() });
    }
    return;
  }

  corelCommunication.sendActionGuarded('health:pong', {
    timestamp: Date.now(),
    apiOnline
  });
}

let intervalId: number | null = null;

/**
 * Inicia envio periódico de health check ao C#.
 * 
 * Envia mensagem `health:pong` a cada 15 segundos com:
 * - timestamp: momento do envio
 * - apiOnline: status da API (se disponível)
 * 
 * Esta é uma mensagem fire-and-forget (não aguarda resposta).
 * O C# usa isso para detectar se o frontend está vivo.
 */
export function startHealthCheck(): void {
  // Evitar inicializar múltiplas vezes
  if (intervalId !== null) {
    return;
  }

  emitHealthPong();
  intervalId = window.setInterval(emitHealthPong, HEALTH_CHECK_INTERVAL);
}

/**
 * Para o envio de health checks.
 * 
 * Útil quando frontend está sendo desmontado ou em situações especiais.
 */
export function stopHealthCheck(): void {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

